import api from '.';

export type ImageInfo = {
  predefinedImage: string;
  customImage?: string;
};

export type Provider = 'pelckmans' | 'smartschool' | 'blink' | 'zogezegd' | 'zogezegd-leerkracht';

type BaseIdentity = {
  id: string;
  fullName: string;
  email?: string;
  url: string;
};

export type KnooppuntIdentity = BaseIdentity & {
  provider: 'knooppunt';
};

export type SmartschoolIdentity = BaseIdentity & {
  provider: 'smartschool';
};

export type OneRoster = {
  enabled: boolean;
  clientId: string;
  clientSecret: string;
};

export type SmartschoolSchool = {
  id: string;
  name: string;
  domain: string;
  userIsAdmin?: boolean;
  isSyncStale?: boolean;
  oneRoster?: OneRoster;
};

export type AccountResponsePayload = {
  id: string;
  firstName: string;
  lastName: string;
  nickName?: string;
  primaryEmail?: string;
  verifiedEmail?: boolean;
  existingPassword?: boolean;
  role: string;
  isCandidateTeacher: boolean;
  background: ImageInfo;
  avatar: ImageInfo;
  identities?: (KnooppuntIdentity | SmartschoolIdentity)[];
  school: {
    id: string;
    name: string;
    address: {
      city: string;
    };
  };
  smartschoolSchools: SmartschoolSchool[];
  unsyncedSmartschoolUrls: string[];
  provider: Provider;
};

export type Subject = {
  id: string;
  name: string;
  alternativeIds?: string[];
};

export type SubjectYear = {
  subject: Subject;
  years: (1 | 2 | 3 | 4 | 5 | 6 | 7)[];
};

export type EducationalNetwork = 'GO' | 'KO' | 'OVSG' | 'RESEAU_OFFICIEL' | 'RESEAU_LIBRE';

export enum EducationalType {
  A_STROOM = 'a-stroom',
  B_STROOM = 'b-stroom',
  ASO = 'ASO',
  TSO = 'TSO',
  KSO = 'KSO',
  BSO = 'BSO',
  KLEUTERONDERWIJS = 'Kleuteronderwijs',
  LAGER_ONDERWIJS = 'Lager onderwijs',
  VOLWASSENENONDERWIJS = 'Volwassenenonderwijs',
}

export type TeacherSchool = {
  id: string;
  name: string;
  address: {
    city: string;
  };
};

export type TeacherProfileResponse = {
  educationalNetworks: EducationalNetwork[];
  educationalTypes: EducationalType[];
  subjectYears: SubjectYear[];
  schools: TeacherSchool[];
  smartschoolSchools: SmartschoolSchool[];
};

export async function fetchTeacherProfile(): Promise<TeacherProfileResponse> {
  const { data } = await api.get<TeacherProfileResponse>('my-account/teacher');

  return data;
}
